import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input } from '@angular/core';
import { TagModule } from 'primeng/tag';

@Component({
    selector: 'fcp-tag',
    imports: [CommonModule, TagModule],
    styleUrl: './fcp-tag.component.less',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.data-e2e-hook]': 'e2e()'
    },
    template: `<p-tag
        [value]="value()"
        [severity]="severity()"
        [rounded]="rounded()"
        [icon]="icon()"
        [styleClass]="styleClass()"
    />`
})
export class FcpTagComponent {
    e2e = input<string | null>(null);
    value = input<string>();
    severity = input<TagSeverity>();
    rounded = input<boolean>(false);
    icon = input<string>('');
    emphasis = input<TagEmphasis>(TagEmphasis.Strong);
    size = input<TagSize>(TagSize.Normal);

    readonly styleClass = computed<string>(() => this.emphasis() + ' ' + this.size());
}

export enum TagSize {
    Normal = 'normal-size',
    Small = 'small-size'
}

export enum TagEmphasis {
    Strong = 'strong',
    Subtle = 'subtle'
}

export enum TagSeverity {
    Primary = 'primary',
    Secondary = 'secondary',
    Promotional = 'contrast',
    Success = 'success',
    Info = 'info',
    Warn = 'warn',
    Danger = 'danger'
}
